<template>
  <div class="amazon-media-multiple-input">
    <div class="form-group row">
      <div class="col-sm-12">
        <draggable v-model="valArray" @end="validate(valArray)">
          <div v-for="(val, index) in valArray" :key="index">
            <div class="card mb-3">
              <accordian-display
              :defaultOpen="true"
              :title="val.fileName"
              :draggable="true"
              :icon="'far fa-fw fa-file'">
                <div class="card-body text-dark">
                  <div class="row">
                    <div class="col-md-5 my-1 text-center">
                      <img
                        v-if="val.key && val.fileType != 'pdf'"
                        class="amazon-preview img-fluid"
                        :src="'https://roscon.s3.amazonaws.com/' + val.key"/>
                    </div>
                    <div class="col-md-7 my-1">
                      <form>
                        <textarea-input
                          v-model="val.location"
                          :options="{
                            label: 'Location',
                            name: 'location',
                            value: val.location,
                            fullWidth: true
                          }">
                        </textarea-input>
                        <radio-input
                          v-model="val.acmProbability"
                          :options="{
                            label: 'ACM Probability',
                            radios: radios.ACM_PROBABILITY,
                            value: val.acmProbability,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                        <radio-input
                          v-model="val.materialCondition"
                          :options="{
                            label: 'Material Condition',
                            radios: radios.MATERIAL_CONDITION,
                            value: val.materialCondition,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                        <textarea-input
                          v-model="val.controlMeasures"
                          :options="{
                            label: 'Control Measures',
                            name: 'controlMeasures',
                            value: val.controlMeasures,
                            fullWidth: true
                          }">
                        </textarea-input>
                        <radio-input
                          v-model="val.friable"
                          :options="{
                            label: 'Friable',
                            radios: radios.FRIABLE,
                            value: val.friable,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                        <radio-input
                          v-model="val.approxCoverage"
                          :options="{
                            label: 'Approx Coverage',
                            radios: radios.APPROX_COVERAGE,
                            value: val.approxCoverage,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                        <radio-input
                          v-model="val.probDisturbance"
                          :options="{
                            label: 'Probability Disturbance',
                            radios: radios.PROBABILITY_DISTURBANCE,
                            value: val.probDisturbance,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                        <radio-input
                          v-model="val.probExposure"
                          :options="{
                            label: 'Probability Exposure',
                            radios: radios.PROBABILITY_EXPOSURE,
                            value: val.probExposure,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                        <radio-input
                          v-model="val.riskLevel"
                          :options="{
                            label: 'Risk Level',
                            radios: radios.RISK_LEVEL,
                            value: val.riskLevel,
                            fullWidth: true,
                            inline: true,
                            index
                          }">
                        </radio-input>
                      </form>
                    </div>
                  </div>
                </div>
              </accordian-display>
              <div class="card-footer text-right">
                <a 
                  :href="'https://roscon.s3.amazonaws.com/' + val.key"
                  target="_blank"
                  class="my-1 btn btn-primary">
                  <i class="fa fa-edit"></i> Edit Image
                </a>
                <button
                  @click.prevent="deleteImage(val)"
                  class="my-1 btn btn-danger">
                  <i class="fa fa-trash"></i> Remove
                </button>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="col-sm-12">
        <div class="upload-btn-wrapper" id="dropzone">
          <button class="btn btn-info upload-button" type="button">
            <i class="fa fa-plus"></i> Add New Hazard
          </button>
          <input
            type="hidden"
            :name="options.name"
            :id="options.name + '-url'"
            :value="value"/>
        </div>
        <div v-if="hasError" class="alert alert-danger my-0">
          {{ hasError }}
        </div>
        <div class="progress" style="height: 20px;" v-show="isUploading">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%' }">
            {{ progress }}%
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'
  import {
    ACM_PROBABILITY,
    MATERIAL_CONDITION,
    FRIABLE,
    APPROX_COVERAGE,
    PROBABILITY_DISTURBANCE,
    PROBABILITY_EXPOSURE,
    RISK_LEVEL
  } from '@/AsbestosHazards'
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import RadioInput from '@/components/inputs/RadioInput'
  import TextareaInput from '@/components/inputs/TextareaInput'
  import {
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'HazardInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      AccordianDisplay,
      Draggable,
      RadioInput,
      TextareaInput
    },
    data () {
      return {
        progress: 0,
        isUploading: false,
        isDirty: false,
        isValid: false,
        valArray: [],
        hasError: false,
        validFileType: /^(image\/(gif|jpe?g|png))$/,
        radios: {
          ACM_PROBABILITY,
          MATERIAL_CONDITION,
          FRIABLE,
          APPROX_COVERAGE,
          PROBABILITY_DISTURBANCE,
          PROBABILITY_EXPOSURE,
          RISK_LEVEL
        }
      }
    },
    computed: {
      height () {
        return this.options.height || 'auto'
      },
      width () {
        return this.options.width || 'auto'
      },
      validationClass,
      validationMessage
    },
    mounted () {
      this.valArray = this.value
      if (this.options.text === false) this.hasText = false
      window.fd.logging = false
      let zone = new window.FileDrop('dropzone', {
        iframe: {
          url: `/api/admin/media-uploader?height=${this.height}&width=${this.width}`,
          fileParam: 'media',
          callbackParam: 'iframeCallback'
        }
      })
      zone.multiple(true)
      let fileName = ''
      let $vm = this
      zone.event('send', function (files) {
        $vm.isUploading = true
        files.each(function (file) {
          fileName = file.name
          $vm.hasError = false
          let uploadErrors = []
          let acceptFileTypes = $vm.validFileType
          if (file.type.length && !acceptFileTypes.test(file.type)) {
            uploadErrors.push('You must upload an image file. Accepted file types: JPG, PNG and GIF')
          }
          if (file.size.length && file.size > 10000000) {
            uploadErrors.push('Filesize is too big')
          }
          if (uploadErrors.length > 0) {
            $vm.progress = 0
            $vm.isUploading = false
            $vm.hasError = uploadErrors.join('\n')
          } else {
            file.event('progress', function (sent, total, xhr, event) {
              $vm.progress = parseInt(sent / total * 100, 10)
            })
            file.event('done', function (xhr) {
              $vm.progress = 0
              $vm.isUploading = false
              let values = $vm.value
              let json = JSON.parse(xhr.responseText)
              values.push({
                key: json.key,
                fileName,
                fileType: json.ext,
                location: '',
                acmProbability: '1',
                materialCondition: '1',
                controlMeasures: '',
                friable: '1',
                approxCoverage: '1',
                probDisturbance: '1',
                probExposure: '1',
                riskLevel: '1'
              })
              $vm.$emit('input', values)
            })
            file.event('error', function (xhr) {
              uploadErrors.push(xhr.responseText)
              $vm.hasError = uploadErrors.join('\n')
            })
            file.sendTo(`/api/admin/media-uploader?height=${$vm.height}&width=${$vm.width}`, {
              extraHeaders: true,
              method: 'POST'
            })
          }
        })
      })
      zone.event('iframeDone', function (json) {
        $vm.progress = 0
        $vm.isUploading = false
        let values = $vm.value
        values.push({
          key: json.key,
          fileName,
          fileType: json.ext,
          location: '',
          acmProbability: '1',
          materialCondition: '1',
          controlMeasures: '',
          friable: '1',
          approxCoverage: '1',
          probDisturbance: '1',
          probExposure: '1',
          riskLevel: '1'
        })
        $vm.$emit('input', values)
      })
      window.fd.addEvent(window.fd.byID('multiple'), 'change', function (e) {
        zone.multiple(e.currentTarget || e.srcElement.checked)
      })
      this.validate(this.value)
    },
    methods: {
      validate (val = this.value) {
        this.$emit('input', val)
        this.isDirty = true
        if (Array.isArray(val) && val.length) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      deleteImage (image) {
        let values = this.value
        values.splice(values.indexOf(image), 1)
        this.$emit('input', values)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/HazardInput.vue